import {Section} from "./Section";
import {formatNumber} from "../../../helpers/format-number";

export class ProductConfigSection extends Section {

  constructor(sectionElement, allConfigSectionElements, pageInfos) {
    super(sectionElement);
    this.id = sectionElement.getAttribute('data-product');
    this.allConfigSections = Array.from(allConfigSectionElements);
    this.configButtonsElement = this.element.querySelector('[data-buttons="product-config"]') || false;
    this.prevSectionButtonElement = this.configButtonsElement.querySelector('[data-button="prev"]') || false;
    this.nextSectionButtonElement = this.configButtonsElement.querySelector('[data-button="next"]') || false;
    this.overwriteButtonsElement = this.element.querySelector('[data-buttons="product-overwrite"]') || false;
    this.formElement = this.element.querySelector('form');
    this.siblingElements = this.allConfigSections.filter(configSection => {
      const CONFIG_SECTION_ID = configSection.getAttribute('data-product');
      return CONFIG_SECTION_ID !== this.id
    });
    this.defaultFormObject = Object.fromEntries(new FormData(this.formElement));
    this.priceValueElement = this.element.querySelector('[data-product-info="price"]')

    ProductConfigSection.pageInfos = pageInfos;
  }

  activateSection() {
    this.element.setAttribute('data-active', 'true');
  }

  showSection(formDataObject = false) {
    const FILL_FORM_DATA_OBJECT = formDataObject || this.defaultFormObject;
    const FORM_FIELDS = this.formElement.elements;
    const TOGGLE_ELEMENTS = this.element.querySelectorAll('[data-toggled-by]');
    const ACTIVATE_ELEMENTS = this.element.querySelectorAll('[data-activated-by]');

    /**
     * RESET PLEATED LOGIC FOR STANDARD
     */
    if (this.id === 'order-product-pleated' && !formDataObject) {
      for (const FORM_FIELD of FORM_FIELDS) {
        if (FORM_FIELD.hasAttribute('data-toggle') && FORM_FIELD.checked) FORM_FIELD.checked = false;
      }

      TOGGLE_ELEMENTS.forEach(toggleElement => toggleElement.classList.add('d-none'));
      ACTIVATE_ELEMENTS.forEach(activateElement => activateElement.classList.add('disabled'));
    }

    Section.updateFormFields(FORM_FIELDS, FILL_FORM_DATA_OBJECT)

    for (const FORM_FIELD of FORM_FIELDS) {
      const FORM_FIELD_NAME = FORM_FIELD.name;
      const FORM_FIELD_VALUE = `${FILL_FORM_DATA_OBJECT[FORM_FIELD_NAME]}`;

      /**
       * MAX_DATA_HANDLING - IF INPUT HAS MAX VALUE SEARCH FOR MAX-FIELD AND SET THE DATA
       */
      if (FORM_FIELD.getAttribute('data-has-max') === 'true') {
        const PARENT_HOLDER = FORM_FIELD.closest('div');
        const MAX_FIELD_HOLDER = PARENT_HOLDER ? PARENT_HOLDER.querySelector('.form-max-field') : false;
        const MAX_FIELD_ELEMENT = MAX_FIELD_HOLDER ? MAX_FIELD_HOLDER.querySelector('input') : false;

        if (FORM_FIELD_VALUE.includes('_max')) {
          MAX_FIELD_HOLDER.setAttribute('data-active', 'true');
          MAX_FIELD_ELEMENT.value = `${FILL_FORM_DATA_OBJECT[MAX_FIELD_ELEMENT.name]}`;
        } else {
          MAX_FIELD_HOLDER.setAttribute('data-active', 'false');
          MAX_FIELD_ELEMENT.value = ''
        }
      }

      if (this.id === 'order-product-pleated') {

        if (FORM_FIELD.hasAttribute('data-toggle') && FORM_FIELD.checked) {
          const TOGGLE_KEY = FORM_FIELD.getAttribute('data-toggle');

          TOGGLE_ELEMENTS.forEach(toggleElement => {
            if (toggleElement.getAttribute('data-toggled-by').includes(TOGGLE_KEY)) {
              toggleElement.classList.remove('d-none');
            } else toggleElement.classList.add('d-none');
          })
        }
      }
    }

    this.activateSection();
    ProductConfigSection.deactivateMainSections();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }

  get formDataObject() {
    return Object.fromEntries(new FormData(this.formElement));
  }

  setConfigPrice(price) {
    this.priceValueElement.innerText = formatNumber(price);
  }

  activateEditButton() {
    this.overwriteButtonsElement.setAttribute('data-active', 'true');
    this.configButtonsElement.setAttribute('data-active', 'false');
  }

  activateConfigButtons() {
    this.overwriteButtonsElement.setAttribute('data-active', 'false');
    this.configButtonsElement.setAttribute('data-active', 'true');
  }
}

export const INSTANTIATE_PRODUCT_CONFIG_SECTIONS = pageInfos => {
  const PRODUCT_CONFIG_SECTIONS_ELEMENTS = document.querySelectorAll('[data-section][data-product]');
  return Array.from(PRODUCT_CONFIG_SECTIONS_ELEMENTS).map(configSection => {
    return new ProductConfigSection(configSection, PRODUCT_CONFIG_SECTIONS_ELEMENTS, pageInfos)
  })
}
